import { apiClient } from './client';

export interface Sector { id: number; name: string; is_active: number }
export interface Subsector { id: number; sector_id: number; name: string; is_active: number }
export interface Donor { id: number; name: string }
export interface CountryLocation { id: number; name: string; level: 'country' }

export const masterDataApi = {
  sectors: () => apiClient.get<{ data: Sector[] }>('/api/sectors'),
  subsectors: (sectorId?: number) => apiClient.get<{ data: Subsector[] }>(`/api/subsectors${sectorId ? `?sectorId=${sectorId}` : ''}`),
  donors: () => apiClient.get<{ data: Donor[] }>('/api/donors'),
  countries: () => apiClient.get<{ data: CountryLocation[] }>('/api/locations/countries'),
};
